import 'modernizr'; // eslint-disable-line
import '../bootstrap';

import tracking from '../modules/tracking';
import formValidation from '../modules/formValidation';
import header from '../modules/header';
import toTop from '../modules/toTop';
import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import datepicker from '../modules/datepicker';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import videoElement from '../modules/videoElement';
import captionSlider from '../modules/captionSlider';
import sliderRow from '../modules/sliderRow';
import news from '../modules/news';
import home from '../modules/home';

import scrollListener from '../helpers/scrollListener';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  formValidation.initialize();
  header.initialize();
  toTop.initialize();
  videoOverlay.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  datepicker.initialize();
  cookieBar.initialize();
  embedWrap();
  whatsapp.initialize();
  alert.initialize();
  mediaRow.initialize();
  videoElement.initialize();
  captionSlider.initialize();
  sliderRow.initialize();
  news.initialize();
  home.initialize();

  scrollListener.start();
};

export default general;
